import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../permissions/usePermissions';
import { getResourceConfig } from '../permissions/constants';
import { usePermissionModal } from '../context/PermissionModalProvider';

export default function RequireWritePermission({ resource, action = 'create', children }) {
  const { canCreate, canUpdate } = usePermissions();
  const { showInsufficientPermissionModal } = usePermissionModal();
  const config = getResourceConfig(resource);
  const hasPermission = action === 'update' ? canUpdate(resource) : canCreate(resource);

  useEffect(() => {
    if (!hasPermission) {
      showInsufficientPermissionModal();
    }
  }, [hasPermission, showInsufficientPermissionModal]);

  if (!hasPermission) {
    return <Navigate to={`/${config.segment}`} replace />;
  }

  return children;
}
